export enum BooleanEnum {
  TRUE = 'true',
  FALSE = 'false'
}
